<template>
  <div>
    <toastification-loading-content ref="loadingToast" />

    <breadcrumb nameNav="recording_request.recording" />

    <b-card class="m-2" no-body v-if="recordingOptions">
      <div class="m-2">
        <b-card-header class="pb-50 text-capitalize px-0 pt-0">
          <h5
            v-if="
              $can('manage_request_record_video', 'Video') ||
              (moment(recordingOptions.authorized_from) <= moment() &&
                moment(recordingOptions.authorized_to) >= moment())
            "
          >
            {{ $t("recording_request.recording") }}
          </h5>
          <h5
            v-if="
              !$can('manage_request_record_video', 'Video') &&
              !(
                moment(recordingOptions.authorized_from) <= moment() &&
                moment(recordingOptions.authorized_to) >= moment()
              )
            "
          >
            {{ $t("recording_request.time_expired") }}
          </h5>
        </b-card-header>

        <template
          v-if="
            $can('manage_request_record_video', 'Video') ||
            (moment(recordingOptions.authorized_from) <= moment() &&
              moment(recordingOptions.authorized_to) >= moment())
          "
        >
          <b-row v-for="camera in cameras" :key="camera.id" class="mb-1 align-items-center">
            <b-col cols="12" md="4">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  :value="camera.camera.name"
                  class="d-inline-block mr-1"
                  disabled
                />
              </div>
            </b-col>
            <b-col cols="12" md="3">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input :value="camera.from" class="d-inline-block mr-1" disabled />
              </div>
            </b-col>
            <b-col cols="12" md="3">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input :value="camera.to" class="d-inline-block" disabled />
              </div>
            </b-col>
            <b-col cols="12" md="2" class="d-flex align-items-center justify-content-end">
              <b-button
                v-if="isApproved"
                squared
                variant="success"
                size="md"
                :title="$t('recording_request.recording')"
                @click="recording(camera)"
              >
                <feather-icon icon="VideoIcon" size="15" />
              </b-button>

              <b-button
                squared
                variant="primary"
                size="md"
                :disabled="!!downloading"
                :title="$t('actions.download')"
                @click="download(camera)"
              >
                <feather-icon icon="DownloadIcon" size="15" />
              </b-button>
            </b-col>
          </b-row>

          <div class="d-flex align-items-center justify-content-end border-top pt-1 mt-1">
            <b-button
              v-if="cameras.length > 1"
              squared
              variant="primary"
              size="md"
              :disabled="!!downloading"
              :title="$t('recording_request.download_all')"
              @click="downloadAll()"
            >
              <feather-icon icon="DownloadCloudIcon" size="15" />
            </b-button>

            <b-button
              v-if="false"
              v-b-modal.send_mail
              squared
              variant="info"
              size="md"
              :title="`${$t('actions.send')} ${$t('email')}`"
            >
              <feather-icon icon="MailIcon" size="15" />
            </b-button>
          </div>
        </template>
      </div>
    </b-card>

    <b-card class="m-2" v-show="showRecording" no-body>
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="6" sm="12">
          <div style="height: 50vh">
            <camera-widget-v-2
              v-if="showRecording && currentCamera"
              :key="`camer-widget-${currentCamera.id}`"
              :pos="1"
              :parent-id="1"
              :camera-id="currentCamera.camera.camera_id"
              :camera-proxy-id="currentCamera.camera.camera_proxy_id"
              :camera-type="currentCamera.camera.camera_type"
              :date-range="dateRange"
              :config="{ layout: 'alarm', synced: false }"
            />
          </div>
        </b-col>
      </b-row>
    </b-card>

    <div>
      <b-modal
        id="send_mail"
        :title="`${$t('actions.send')} ${$t('email')}`"
        v-if="modalShow"
        @hidden="resetForm"
        hide-footer
      >
        <template>
          <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
            <!-- Form -->
            <b-form
              class="p-2"
              @submit.prevent="handleSubmit(onSubmit)"
              @reset.prevent="resetForm"
            >
              <!-- email -->
              <validation-provider
                #default="validationContext"
                name="email"
                rules="required"
              >
                <b-form-group
                  class="text-capitalize"
                  :label="$t('messages.validation.email_placeholder')"
                  label-for="email"
                  :state="getValidationState(validationContext)"
                >
                  <b-form-tags
                    input-id="tags-basic"
                    v-model="email"
                    tag-variant="primary"
                    placeholder=""
                  ></b-form-tags>

                  <b-form-invalid-feedback :state="getValidationState(validationContext)">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <b-button variant="primary" class="mt-2 float-right" type="submit">
                {{ $t("actions.send") }}
              </b-button>
            </b-form>
          </validation-observer>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormGroup,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BFormInvalidFeedback,
  BPagination,
  BCardGroup,
  BFormTags,
  BCardHeader,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import useList from "./useList";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "@axios";
import moment from "moment-timezone";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required } from "@validations";
import Breadcrumb from "@/components/Breadcrumb.vue";
import CameraWidgetV2 from "../../components/GridView/widgets/CameraWidgetV2.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BCardGroup,
    vSelect,
    ToastificationLoadingContent,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BFormTags,
    BCardHeader,
    Breadcrumb,
    CameraWidgetV2,
  },
  data() {
    return {
      required,
    };
  },
  setup(_, context) {
    const showRecording = ref(false);
    const modalShow = ref(true);
    const loadingToast = ref(null);
    const email = ref(null);
    const dateRange = ref({ start: null, end: null });
    const currentCamera = ref(null);

    const resetData = () => {
      email.value = [];
    };

    const recording = (camera) => {
      if (currentCamera.value && currentCamera.value.id === camera.id) {
        showRecording.value = !showRecording.value;
        return;
      }

      currentCamera.value = camera;
      dateRange.value = { start: camera.from, end: camera.to };
      showRecording.value = true;
    };

    const onSubmit = () => {
      loadingToast.value.show(
        context.parent.$i18n.t("messages.info.sending"),
        "Enviado correo...",
        "secondary"
      );
      modalShow.value = false;

      let data = {
        emails: JSON.parse(JSON.stringify(email.value)),
      };

      axios
        .post(`v1/email/recording_request/${idRecording}`, data)
        .then((resp) => {
          if (resp.data.success) {
            loadingToast.value.close();
            modalShow.value = true;
            toast({
              component: ToastificationContent,
              props: {
                title: resp.data.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });
          } else {
            loadingToast.value.close();
            modalShow.value = true;
            toast({
              component: ToastificationContent,
              props: {
                title: resp.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((e) => {
          loadingToast.value.close();
          modalShow.value = true;
          toast({
            component: ToastificationContent,
            props: {
              title: context.parent.$i18n.t("messages.error.server_error"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const toast = useToast();

    const {
      formatDateAssigned,
      recordingOptions,
      cameras,
      isApproved,
      idRecording,
      downloading,
      download,
      downloadAll,
    } = useList();

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetData);

    return {
      loadingToast,
      formatDateAssigned,
      recordingOptions,
      cameras,
      isApproved,
      idRecording,
      downloading,
      download,
      downloadAll,
      currentCamera,
      recording,
      showRecording,
      modalShow,
      email,
      moment,
      resetData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
      dateRange,
    };
  },
};
</script>
